import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';

import { FindVisualsByTargetCacheGQL, VisualsType } from '@sifca-monorepo/ecommerce-generator';

@Injectable({
  providedIn: 'root',
})
export class VisualsService {
  private visuals: BehaviorSubject<VisualsType | null> = new BehaviorSubject(null);

  constructor(private findVisualsByTargetGQL: FindVisualsByTargetCacheGQL) {}

  get visuals$(): Observable<VisualsType> {
    return this.visuals.asObservable();
  }

  getVisuals(pos: string): Observable<VisualsType> {
    return this.findVisualsByTargetGQL
      .fetch({
        target: { pos },
      })
      .pipe(
        map((response: any) => {
          if (response.data) {
            this.visuals.next(response.data.findVisualsByTargetCache);
            return response.data.findVisualsByTargetCache;
          }
        }),
      );
  }
}
